<template>
    <div class="conter">
        <div class="title">水系统选型配置</div>
        <div class="currency_suggest">
            <div class="titel">
                <span>设计依据</span>
            </div>
            <div class="title_xiao">用水需求</div>
            <div class="demand">
                <div class="demand_conter">
                    <div class="demand_top">
                        <div class="situat_item">
                            <span class="label">用水点</span>
                            <span class="room_type"
                                >{{
                                    reporInfo.numToilet
                                        ? reporInfo.numToilet + "卫"
                                        : "0卫"
                                }}{{
                                    reporInfo.numKitchen
                                        ? reporInfo.numKitchen + "厨"
                                        : "0厨"
                                }}</span
                            >
                        </div>
                        <div class="situat_item">
                            <span class="label">洗浴习惯</span>
                            <span class="room_type">{{
                                reporInfo.bath_habit
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="personnel">
                    <div
                        class="personnel_conter"
                        v-for="(item, index) in reporInfo.tags"
                        v-show="item.type == 3"
                        :key="index"
                    >
                        <div class="per_laber">
                            <span :class="['btn_laber', item.nameClass]">{{
                                item.name
                            }}</span>
                            <span
                                class="eait"
                                v-if="!reporInfo.bShowCard"
                                @click="
                                    getEait(
                                        bShowWaterText
                                            ? item.arrWater
                                            : item.strHuasa,
                                        item.type,
                                        index,
                                        bShowWaterText
                                            ? item.tag_id
                                            : item.tag_huasa_id
                                    )
                                "
                            ></span>
                        </div>
                        <div
                            class="per_textar"
                            v-html="
                                bShowWaterText ? item.arrWater : item.strHuasa
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="currency_suggest">
            <div class="titel">
                <span>系统选型</span>
            </div>
            <div class="title_xiao">系统设计参数</div>
            <div class="warp_can">
                <div class="can_top">
                    <div class="situat_item" style="width: 48%">
                        <span class="label">用水人数</span>
                        <span class="room_type">{{
                            reporInfo.config_num
                                ? reporInfo.config_num + "人"
                                : ""
                        }}</span>
                    </div>
                    <div class="situat_item">
                        <span class="label">热水设计流量</span>
                        <span class="room_type">{{
                            Number(
                                reporInfo.arrWaterSub.length
                                    ? reporInfo.arrWaterSub[nRoomIndex]
                                          .water_rate
                                    : reporInfo.sub[nRoomIndex].water_rate
                            ).toFixed(1) + "L/min"
                        }}</span>
                    </div>
                    <div class="situat_item" style="width: 48%">
                        <span class="label">冬季进水温度</span>
                        <span class="room_type">{{
                            Number(reporInfo.water_cold).toFixed(1) + "℃"
                        }}</span>
                    </div>
                    <div class="situat_item">
                        <span class="label">热水需求负荷</span>
                        <span class="room_type">{{
                            Number(reporInfo.water_energy).toFixed(1) + "Kw"
                        }}</span>
                    </div>
                    <div class="situat_item" style="width: 48%">
                        <span class="label">最大净水用量</span>
                        <span class="room_type">{{
                            Number(reporInfo.water_clean).toFixed(1) + "t/h"
                        }}</span>
                    </div>
                    <div class="situat_item">
                        <span class="label">最大软水用量</span>
                        <span class="room_type">{{
                            Number(reporInfo.water_soft).toFixed(1) + "t/h"
                        }}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="lytab" v-if="reporInfo.arrWaterSub.length > 1">
        <div
          class="lytab_list"
          :style="{ width: reporInfo.arrWaterSub.length < 5 ? '100%' : '' }"
        >
          <div class="arrRooms">
            <div
              :class="[
                nRoomIndex == index ? 'actRoomNav' : '',
                reporInfo.arrWaterSub.length < 5 ? 'roomNav' : 'xRoomNav',
              ]"
              :style="{
                width:
                  reporInfo.arrWaterSub.length < 5
                    ? 100 / reporInfo.arrWaterSub.length + '%'
                    : '',
              }"
              v-for="(item, index) in reporInfo.arrWaterSub"
              :key="index"
              @click="getRoom(index)"
            >
              {{ item.room | roomNumber }}
            </div>
          </div>
          <div :class="['second_nav_strip']">
            <div
              :class="[reporInfo.arrWaterSub.length < 5 ? 'strip' : 'nostrips']"
              :style="{
                left: (100 / reporInfo.arrWaterSub.length) * nRoomIndex + '%',
                width:
                  reporInfo.arrWaterSub.length < 5
                    ? 100 / reporInfo.arrWaterSub.length + '%'
                    : '',
              }"
            ></div>
          </div>
        </div>
      </div> -->
            <div class="title_xiao" v-if="reporInfo.arrDeaWater.length">
                系统设备配置
            </div>
            <div class="shopp_conter" v-if="reporInfo.arrDeaWater.length">
                <div
                    class="shopp_list"
                    v-for="(item, index) in reporInfo.arrDeaWater"
                    @click="getDetails(item.product_id)"
                    :key="index"
                >
                    <div class="shopp_img">
                        <img v-lazy="item.mobile_img" alt="" />
                    </div>
                    <div class="shopp_text">
                        <div>{{ item.new_goods_type_name }}</div>
                        <div class="text_item">{{ item.goods_name }}</div>
                        <div>
                            <div
                                class="situat_item"
                                v-for="(attritem, attrindex) in item.attr_two"
                                :key="attrindex"
                            >
                                <span class="label">{{
                                    attritem.attr_name
                                }}</span>
                                <span class="room_type">{{
                                    attritem.attr_value
                                }}</span>
                            </div>
                        </div>
                        <!-- 数量 -->
                        <div class="shopp_num">x{{ item.num }}</div>
                    </div>
                </div>
            </div>
        </div>
        <textInput
            :bShowIput.sync="bShowIput"
            :sText.sync="sText"
            :nType.sync="nType"
            :nIndex.sync="nIndex"
            :tagId.sync="tagId"
            :category.sync="category"
            @sumbit="sumbitzi"
        ></textInput>
    </div>
</template>
<script>
import textInput from "../../components/textinput/index";
export default {
    components: {
        textInput,
    },
    props: {
        bShowWaterText: {
            type: Boolean,
            default: false,
        },
        reporInfo: {
            type: Object,
            default: false,
        },
    },
    data() {
        return {
            bShowIput: false,
            nRoomIndex: 0,
            arrRooms: [],
            nType: 0, //类型
            sText: "", //需要修改的文本
            nIndex: 0,
            tagId: 0, //标签id
            category: 1, //区分是水系统还是新风系统ailink
        };
    },
    filters: {
        roomNumber(index) {
            // console.log("-->计算属性", index);
            let arr = [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
            ];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
    },
    methods: {
        //查看商品详情
        getDetails(id) {
            this.$router.push({ path: `/shopp/details?id=${id}` });
        },
        sumbitzi(e) {
            // console.log("sumbit", e);
            this.$emit("sumbitzi", e);
        },
        //点击编辑文本
        getEait(html_deas, type, index, tag_id) {
            this.nIndex = Number(index);
            // console.log(this.nIndex, index);
            this.nType = type;
            this.tagId = Number(tag_id);
            //  console.log(tag_id);
            this.sText = html_deas.replace(/<br\/>/g, "\r\n");
            this.bShowIput = true;
        },
        getRoom(index) {
            this.nRoomIndex = index;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
